import { getAccessToken } from './tokenBridge'

export type SessionEndedReason = 'expired' | 'signed-out'

const ABANDONED_SIGN_OUT_MS = 30000

let handler: ((reason: SessionEndedReason) => void) | null = null
let pendingReason: SessionEndedReason | null = null
let pendingToken: string | null = null
let sessionEnded = false
let signingOutSince: number | null = null

export const setSessionExpiredHandler = (
  fn: ((reason: SessionEndedReason) => void) | null
) => {
  handler = fn

  if (!fn || !pendingReason) return

  const reason = pendingReason
  const queuedToken = pendingToken
  pendingReason = null
  pendingToken = null

  // A notice raised against a token we have since replaced belongs to a
  // session the user has already recovered from.
  if (queuedToken && getAccessToken() !== queuedToken) return

  sessionEnded = true
  fn(reason)
}

export const notifySessionExpired = (
  reason: SessionEndedReason = 'expired'
) => {
  if (handler) {
    sessionEnded = true
    handler(reason)
  } else {
    pendingReason = reason
    pendingToken = getAccessToken()
  }
}

export const hasSessionEnded = () => sessionEnded

export const resetSessionEnded = () => {
  sessionEnded = false
  pendingReason = null
  pendingToken = null
}

export const clearSessionEnded = () => {
  resetSessionEnded()
  signingOutSince = null
}

export const markSigningOut = () => {
  signingOutSince = Date.now()
}

// A sign-out that has not navigated away by now never will, so stop letting it
// suppress the dialog for the rest of the page's life.
export const isSigningOut = () =>
  signingOutSince !== null &&
  Date.now() - signingOutSince < ABANDONED_SIGN_OUT_MS
